// @ts-nocheck
// datatable related plugins
import { yupResolver } from "@hookform/resolvers/yup";
import { TYPE_INVOICE_ANOTHER } from "constants/IssueInvoiceConstant";
import { Vietnamese } from "flatpickr/dist/l10n/vn";
import { generateDateField } from "helpers/form_helper_old";
import { convertDate } from "helpers/utils";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { Button, Card, CardBody, Col, Row } from "reactstrap";
import { listIssueInvoice, resetSetBuStoreHeader } from "store/actions";
import { SET_BU_STORE_HEADER_SUCCESS } from "store/dashboard/actionTypes";
import * as yup from "yup";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import ListInvoice from "./ListInvoice";

const CreateData = props => {
  const dispatch = useDispatch();
  const initOptionDateLocale = {
    altInput: true,
    altFormat: "d/m/Y",
    dateFormat: "d/m/Y",
    allowInput: true,
    locale: {
      ...Vietnamese,
      firstDayOfWeek: 1,
    },
  };

  const [optionDateLocale, setOptionDateLocale] = useState({
    ...initOptionDateLocale,
  });

  const history = useHistory();

  const Dashboard = useSelector(state => state.Dashboard);
  const { type: typeDashboard } = Dashboard;
  const issueInvoice = useSelector(state => state.issueInvoice);
  const { list: issueInvoiceList } = issueInvoice;

  useEffect(() => {
    return () => {};
  }, []);

  useEffect(() => {
    if (typeDashboard === SET_BU_STORE_HEADER_SUCCESS && isCheckChangeStore) {
      queryData(filterList);
      dispatch(resetSetBuStoreHeader());
    }
  }, [typeDashboard]);

  const schema = yup.object().shape({
    // THông tin chung
    dateRange: yup.array().min(2, "Vui lòng chọn khoảng thời gian"),
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
    watch,
    setFocus,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      dateRange: [],
    },
  });

  const [label, setLabel] = useState("");

  const onSubmit = values => {
    const filter = {
      "filter[invoice_date][gte]": convertDate(values.dateRange[0], "date"),
      "filter[invoice_date][lte]": convertDate(values.dateRange[1], "date"),
    };
    setIsCheckChangeStore(true);
    setLabel(
      `(Từ ngày ${convertDate(
        values.dateRange[0],
        "label"
      )} - Đến ngày ${convertDate(values.dateRange[1], "label")})`
    );
    setFilterList(filter);
    queryData(filter);
  };

  const [filterList, setFilterList] = useState({});

  const [isCheckChangeStore, setIsCheckChangeStore] = useState(false);

  const queryData = filter => {
    issueInvoiceList.params.page = 1;
    issueInvoiceList.params.columnFilter = {
      ...issueInvoiceList.params.columnFilter,
      ...filter,
    };
    dispatch(
      listIssueInvoice(
        issueInvoiceList.params,
        TYPE_INVOICE_ANOTHER.INVOICE_TOTAL
      )
    );
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Danh sách hóa đơn tổng </title>
        </MetaTags>
        <div className="container-fluid">
          <Breadcrumbs
            title=""
            breadcrumbItem={"Danh sách hóa đơn tổng " + label}
          />
          <Card>
            <CardBody>
              <Row className="row-cols-1 row-cols-md-3 mb-3">
                <Col style={{ width: "250px" }}>
                  {generateDateField(
                    "Từ ngày",
                    "Đến ngày",
                    false,
                    errors,
                    "dateRange",
                    "DD/MM/YYYY ~ DD/MM/YYYY",
                    false,
                    control,
                    {
                      ...optionDateLocale,
                      mode: "range",
                      // enableTime: true,
                      // dateFormat: "Y-m-d",
                      // dateFormat: "H:i",
                      // time_24hr: true,
                    }
                  )}
                </Col>
                <Col>
                  <div className="mt-4 d-flex">
                    <Button
                      style={{ marginTop: "2px" }}
                      type="button"
                      color="primary"
                      className="me-2 btn-label"
                      //   disabled={
                      //   }
                      onClick={() => {
                        handleSubmit(onSubmit)();
                      }}
                    >
                      <i className="bx bxs-report label-icon" />
                      Tìm hóa đơn
                    </Button>
                  </div>
                </Col>
              </Row>
              <ListInvoice filterList={filterList} />
            </CardBody>
          </Card>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CreateData;
